export default __webpack_public_path__ + "static/media/TR_Printing_rules_inches.e6265bbd.pdf";